import requst from '@/utils/requst'


// 检测列表
export function list(params) {
  return requst({
    method: 'get',
    url: 'ewater/obsinfo',
    params
  })
}

// 设备信息
export function getInfo(params) {
  return requst({
    method: 'get',
    url: 'ewater/devinfo',
    params
  })
}

// 更新频率
export function refreshRate(params) {
  return requst({
    method: 'get',
    url: 'ewater/span',
    params
  })
}

// 获取光谱
export function getSpectrum(params) {
  return requst({
    method: 'get',
    url: 'ewater/getSpectrum',
    params
  })
}

// 获取谱图
export function downloadfile(id) {
  return requst({
    method: 'get',
    url: `ewater/spectral/downloadfile/${id}`,
    responseType: 'blob'
  })
}


// 设置零光谱
export function setZero(params) {
  return requst({
    method: 'POST',
    url: `ewater/RefZero`,
    params
  })
}

// 获取光谱设备当前指标

export function getElements(params) {
  return requst({
    method: 'get',
    url: `ewater/elements`,
    params
  })
}


// 根据id 获取谱图溯源

export function getTrace(data) {
  return requst({
    method: 'POST',
    url: `ewater/spectral/kjtrace`,
    data
  })
}
